import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

// Redux type and action creators
const { Types, Creators } = createActions({
  streetviewAdded: ['lngLat'],
  streetviewRemoved: [],
  serviceCardChanged: [],
  reset: []
})

export const StreetviewTypes = Types
export default Creators

// Initial state
export const INITIAL_STATE = Immutable({
  lngLat: null
})

// Redux reducers
export const streetviewAdded = (state, { lngLat }) => {
  return state.merge({ lngLat })
}

export const streetviewRemoved = (state) => {

  return state.merge({ lngLat: null })
}

export const reset = state => {
  return INITIAL_STATE
}

// Assign types to reducers
export const reducer = createReducer(INITIAL_STATE, {
  [Types.STREETVIEW_ADDED]: streetviewAdded,
  [Types.STREETVIEW_REMOVED]: streetviewRemoved,
  [Types.SERVICE_CARD_CHANGED]: reset,
  [Types.RESET]: reset
})



// WEBPACK FOOTER //
// ./src/redux/streetviewRedux.js